import { AxiosRestApplicationClient as RiskAxiosRestApplicationClient } from '@g2-shared/api-client/generated/risk-app';
import {
  generateBaseAxiosClient,
  INotificationService,
  NotificationsService,
} from '@g2-shared/common';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const RiskApiClient = new RiskAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  RiskApiClient: RiskAxiosRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  RiskApiClient,
  NotificationService: NotificationsService,
});
